export const medium = 'https://medium.com/@lhc.geelen';
export const github = 'https://github.com/LuuckyG';
export const linkedin = 'https://linkedin.com/in/luuk-geelen-184806a9';